var _defs, _circle, _path, _circle2, _text, _text2, _polygon, _polyline, _polyline2, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleForEducation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 340 340",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "top",
    d: "M 62 170 A 108 108 0 0 1 278 170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bottom",
    d: "M 52 170 A 118 118 0 0 0 288 170"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 170,
    r: 160,
    fill: "#F1F3F4",
    stroke: "#DADCE0",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 36 170 A 134 134 0 0 0 304 170",
    fill: "none",
    stroke: "#BDC1C6",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 170,
    r: 92,
    fill: "#fff",
    stroke: "#FBBC04",
    strokeWidth: 16
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontFamily: "'Google Sans', Poppins, Arial, sans-serif",
    fontSize: 27,
    fill: "#5F6368"
  }, /*#__PURE__*/React.createElement("textPath", {
    href: "#top",
    startOffset: "50%",
    textAnchor: "middle"
  }, "Google for Education"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "'Google Sans', Poppins, Arial, sans-serif",
    fontSize: 25,
    fill: "#5F6368",
    dominantBaseline: "hanging"
  }, /*#__PURE__*/React.createElement("textPath", {
    href: "#bottom",
    startOffset: "50%",
    textAnchor: "middle"
  }, "Credential"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "170,128 228,154 170,180 112,154",
    fill: "none",
    stroke: "#EA4335",
    strokeWidth: 9,
    strokeLinejoin: "round"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "136,166 136,198 170,214",
    fill: "none",
    stroke: "#34A853",
    strokeWidth: 9,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "170,214 204,198 204,166",
    fill: "none",
    stroke: "#4285F4",
    strokeWidth: 9,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 222,
    y1: 157,
    x2: 222,
    y2: 196,
    stroke: "#FBBC04",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleForEducation);
export default __webpack_public_path__ + "static/media/google-for-education.ce3706a924357f2a956d57d5fdab598b.svg";
export { ForwardRef as ReactComponent };